/* KrakenTheMeta dashboard — the deck library, the "new deck" sheet (AI / empty / import),
 * the shared AI options form, and the generation run that ties them to the builder.
 */
(function () {
  "use strict";

  var KD = window.KD, S = KD.state, D = KD.data, esc = KD.esc;

  // ================================================================ library

  var libState = { q: "", format: "all", sort: "recent" };
  var repaint = null;
  document.addEventListener("kd:decks", function () { if (repaint) repaint(); });

  KD.routes.decks = function (view) {
    view.innerHTML =
      '<div class="vhead"><div class="vhead__text"><p class="depth-tag">Your armory</p><h2>Decks</h2></div>' +
        '<div class="vhead__actions"><button class="btn btn--lure" type="button" data-create>' + KD.icon("plus") + "<span>New deck</span></button></div></div>" +
      '<div class="toolbar">' +
        '<label class="inputwrap">' + KD.icon("search") + '<input class="input" type="search" placeholder="Search your decks" data-q value="' + esc(libState.q) + '" aria-label="Search your decks"></label>' +
        '<select class="select" style="width:auto" data-sort aria-label="Sort decks">' +
          '<option value="recent">Recently edited</option><option value="name">Name A–Z</option><option value="size">Most cards</option></select>' +
      "</div>" +
      '<div class="chips" data-formats-filter></div>' +
      '<div class="dgrid mt-16" data-grid>' + KD.deckSkeletons(8) + "</div>";

    var grid = KD.$("[data-grid]", view);
    KD.$("[data-sort]", view).value = libState.sort;
    KD.$("[data-q]", view).addEventListener("input", function (e) { libState.q = e.target.value; paint(); });
    KD.$("[data-sort]", view).addEventListener("change", function (e) { libState.sort = e.target.value; paint(); });

    function paint() {
      var decks = (S.decks || []).slice();
      var formats = {};
      decks.forEach(function (d) { var f = D.formatLabel(d.format); formats[f] = (formats[f] || 0) + 1; });
      var chips = KD.$("[data-formats-filter]", view);
      var keys = Object.keys(formats).sort();
      chips.innerHTML = keys.length > 1 ? ['<button class="chip' + (libState.format === "all" ? " is-on" : "") + '" type="button" data-f="all">All <small>' + decks.length + "</small></button>"]
        .concat(keys.map(function (f) { return '<button class="chip' + (libState.format === f ? " is-on" : "") + '" type="button" data-f="' + esc(f) + '">' + esc(f) + " <small>" + formats[f] + "</small></button>"; })).join("") : "";
      KD.$$("[data-f]", chips).forEach(function (b) { b.addEventListener("click", function () { libState.format = b.dataset.f; paint(); }); });

      var q = libState.q.trim().toLowerCase();
      var list = decks.filter(function (d) {
        return (libState.format === "all" || D.formatLabel(d.format) === libState.format) && (!q || (d.name || "").toLowerCase().indexOf(q) !== -1);
      });
      if (libState.sort === "name") list.sort(function (a, b) { return (a.name || "").localeCompare(b.name || ""); });
      if (libState.sort === "size") list.sort(function (a, b) { return (b.cardCount || 0) - (a.cardCount || 0); });

      if (!decks.length) {
        grid.innerHTML = '<div class="empty panel" style="grid-column:1/-1">' + KD.icon("layers") + "<h3>Your armory is empty</h3>" +
          "<p>Describe a deck and the Kraken builds it, or start one by hand and add cards yourself.</p>" +
          '<button class="btn btn--lure" type="button" data-create>' + KD.icon("sparkle") + "Build your first deck</button></div>";
        return;
      }
      if (!list.length) { grid.innerHTML = '<div class="empty" style="grid-column:1/-1">' + KD.icon("search") + "<p>No decks match that.</p></div>"; return; }
      grid.innerHTML = list.map(function (d) {
        return '<div style="position:relative">' + KD.deckCard(d, S.published && S.published[d.id]) +
          '<div class="dcard__more"><button class="iconbtn iconbtn--sm" type="button" data-deckmenu="' + esc(d.id) + '" aria-label="Deck options">' + KD.icon("dots") + "</button></div></div>";
      }).join("") + '<button class="dcard dcard--new" type="button" data-create>' + KD.icon("plus") + "New deck</button>";
      KD.$$("[data-deckmenu]", grid).forEach(function (b) {
        b.addEventListener("click", function (e) {
          e.preventDefault(); e.stopPropagation();
          var d = S.decks.find(function (x) { return x.id === b.dataset.deckmenu; });
          if (d) deckMenu(b, d, paint);
        });
      });
    }

    repaint = function () { if (KD.parseRoute().name === "decks" && document.body.contains(grid) && S.decks) paint(); };
    Promise.all([D.loadDecks(), D.loadPublished()]).then(function () {
      paint();
      D.hydrateDeckCounts().then(function (changed) { if (changed) paint(); });
    }).catch(function (e) {
      console.error(e);
      grid.innerHTML = '<div class="empty" style="grid-column:1/-1">' + KD.icon("alert") + "<p>Couldn't load your decks. Refresh to try again.</p></div>";
    });
  };

  function deckMenu(anchor, d, repaint) {
    var pub = S.published && S.published[d.id];
    var items = [
      { label: "Open", icon: "layers", onClick: function () { KD.go("deck/" + d.id); } },
      { label: "Rename", icon: "pen", onClick: async function () {
        var n = await KD.ask({ title: "Rename deck", label: "Deck name", value: d.name, max: 80 });
        if (!n) return;
        try { await D.setDeckName(d.id, n); repaint(); KD.toast("Renamed.", "ok"); } catch (e) { KD.toast("Rename failed.", "err"); }
      } }
    ];
    if (pub) items.push({ label: "View public page", icon: "external", href: KD.SITE + "/deck-view?deckId=" + encodeURIComponent(pub), external: true });
    items.push("sep", { label: "Delete deck", icon: "trash", danger: true, onClick: function () { KD.deleteDeckFlow(d, repaint); } });
    KD.menu(anchor, items, d.name);
  }

  KD.deleteDeckFlow = async function (d, after) {
    var pub = S.published && S.published[d.id];
    var ok = await KD.confirm({
      title: "Delete “" + (d.name || "this deck") + "”?",
      body: "<p>This deletes the deck and all of its cards" + (pub ? ", and removes its public page from the community gallery" : "") + ". It can't be undone.</p>",
      confirm: "Delete deck", danger: true
    });
    if (!ok) return false;
    KD.busy("Deleting…");
    try { await D.deleteDeck(d.id); KD.idle(); KD.toast("Deck deleted.", "ok"); if (after) after(); return true; }
    catch (e) { console.error(e); KD.idle(); KD.toast("Couldn't delete the deck. Try again.", "err"); return false; }
  };

  // ================================================================ the AI options form
  // Shared by the "new deck" sheet and the builder's AI tab. read() returns what D.generate needs.

  KD.aiForm = function (host, o) {
    o = o || {};
    var format = o.format || "commander";
    var isCmd = function () { return D.isCommanderFormat(format); };
    host.innerHTML =
      '<div class="aiform">' +
        (o.showFormat ? '<div class="field"><span class="label">Format</span><div class="chips" data-ai-formats>' +
          D.FORMATS.map(function (f) { return '<button class="chip' + (f[0] === format ? " is-on" : "") + '" type="button" data-fmt="' + f[0] + '">' + f[1] + "</button>"; }).join("") +
          "</div></div>" : "") +
        '<label class="field aiform__prompt"><span class="label">Describe the deck</span>' +
          '<textarea class="textarea" data-ai-prompt maxlength="600" placeholder="A zombie tribal Commander deck that recurs everything from the graveyard…">' + esc(o.prompt || "") + "</textarea></label>" +
        '<label class="field" data-cmd-field><span class="label">Commander (optional)</span>' +
          '<input class="input" data-ai-commander maxlength="80" placeholder="e.g. Atraxa, Praetors’ Voice">' +
          '<span class="hint">The other 99 cards are built to its colors. Leave blank and the Kraken picks one.</span></label>' +
        '<label class="check" data-coll-wrap><input type="checkbox" data-ai-coll><span>Only use cards from my collection</span></label>' +
        '<p class="hint aiform__sub" data-coll-empty hidden>Your collection is empty. <a href="#/collection" data-close>Add cards to it</a> and this unlocks.</p>' +
        '<div class="aiform__sub stack" data-coll-opts hidden>' +
          '<p class="hint">Cards you own are used even if they aren’t legal in this format: great for the kitchen table, not for ranked queues.</p>' +
          '<label class="field" data-binder-field hidden><span class="label">Build from</span><select class="select" data-ai-binder><option value="">My whole collection</option></select></label>' +
          '<label class="check"><input type="checkbox" data-ai-noreuse><span>Don’t reuse cards my other decks already use</span></label>' +
          '<p class="hint" data-noreuse-hint hidden></p>' +
        "</div>" +
        "<details data-adv><summary>More options" + KD.icon("down") + "</summary><div class=\"aiform__adv\">" +
          (o.showName ? '<label class="field"><span class="label">Deck name (optional)</span><input class="input" data-ai-name maxlength="80" placeholder="Leave blank and the Kraken names it"></label>' : "") +
          '<label class="field"><span class="label">Card pool</span><select class="select" data-ai-pool>' +
            '<option value="legal">Tournament legal: only cards legal in the format</option><option value="casual">Casual: any real Magic card</option></select></label>' +
          '<div class="aiform__row">' +
            '<label class="field" data-budget-field><span class="label">Budget ($, optional)</span><input class="input" type="number" min="5" inputmode="numeric" data-ai-budget placeholder="No limit"></label>' +
            '<label class="field" data-bracket-field><span class="label">Commander bracket</span><select class="select" data-ai-bracket>' +
              '<option value="">Any power level</option><option value="1">1 — Exhibition</option><option value="2">2 — Core</option><option value="3">3 — Upgraded</option><option value="4">4 — Optimized</option><option value="5">5 — cEDH</option></select></label>' +
          "</div>" +
          '<label class="field"><span class="label">Must include (optional)</span><textarea class="textarea" data-ai-include style="min-height:72px" placeholder="One per line, up to 20"></textarea></label>' +
          '<label class="field"><span class="label">Leave out (optional)</span><textarea class="textarea" data-ai-exclude style="min-height:72px" placeholder="One per line, up to 20"></textarea></label>' +
        "</div></details>" +
      "</div>";

    var $ = function (s) { return KD.$(s, host); };
    function syncFormat() {
      $("[data-cmd-field]").hidden = !isCmd();
      $("[data-bracket-field]").hidden = !isCmd();
    }
    syncFormat();
    KD.$$("[data-fmt]", host).forEach(function (b) {
      b.addEventListener("click", function () {
        format = b.dataset.fmt;
        KD.$$("[data-fmt]", host).forEach(function (x) { x.classList.toggle("is-on", x === b); });
        syncFormat();
        if (o.onFormat) o.onFormat(format);
      });
    });

    // collection-only builds: guard against an empty collection, show the binder + no-reuse options
    var coll = $("[data-ai-coll]");
    function syncColl() {
      var on = coll.checked;
      $("[data-coll-opts]").hidden = !on;
      $("[data-budget-field]").hidden = on; // budget doesn't apply to cards you already own
      $("[data-binder-field]").hidden = !on || !S.binders.length;
    }
    coll.addEventListener("change", syncColl);
    D.loadCollection().then(function () {
      var empty = S.collectionLoaded && !S.collection.length;
      coll.disabled = empty;
      $("[data-coll-wrap]").classList.toggle("is-disabled", empty);
      $("[data-coll-empty]").hidden = !empty;
      if (o.useCollection && !empty) coll.checked = true;
      if (empty && coll.checked) { coll.checked = false; }
      var sel = $("[data-ai-binder]");
      sel.innerHTML = '<option value="">My whole collection</option>' + S.binders.map(function (b) { return '<option value="' + esc(b.id) + '">' + esc(b.name) + "</option>"; }).join("");
      syncColl();
    }).catch(function () {});
    $("[data-ai-noreuse]").addEventListener("change", async function (e) {
      var hint = $("[data-noreuse-hint]");
      if (!e.target.checked) { hint.hidden = true; return; }
      hint.hidden = false;
      hint.textContent = "Checking your other decks…";
      try {
        var r = await D.computeReserved(o.deckId || "__new__");
        var names = Object.keys(r.map).length, copies = Object.values(r.map).reduce(function (a, b) { return a + b; }, 0);
        hint.textContent = names ? copies + " " + KD.plural(copies, "copy", "copies") + " of " + names + " " + KD.plural(names, "card") + " are held by " + r.deckCount + " other " + KD.plural(r.deckCount, "deck") + " and won't be used. Basic lands are always available."
          : "No overlap: your other decks don't hold anything this build would use.";
      } catch (err) { hint.textContent = "Couldn't check your other decks right now. Untick and tick again to retry."; }
    });

    function list(sel) {
      return ($(sel).value || "").split(/[\n,]/).map(function (s) { return s.trim(); }).filter(Boolean)
        .filter(function (v, i, a) { return a.findIndex(function (x) { return x.toLowerCase() === v.toLowerCase(); }) === i; }).slice(0, 20);
    }
    return {
      prompt: function () { return $("[data-ai-prompt]").value.trim(); },
      focus: function () { var t = $("[data-ai-prompt]"); t.focus(); t.setSelectionRange(t.value.length, t.value.length); },
      format: function () { return format; },
      read: function () {
        var useCollection = coll.checked && !coll.disabled;
        var exclude = list("[data-ai-exclude]");
        var ex = new Set(exclude.map(function (s) { return s.toLowerCase(); }));
        var budget = Number($("[data-ai-budget]").value);
        return {
          prompt: $("[data-ai-prompt]").value.trim(),
          name: o.showName ? $("[data-ai-name]").value.trim().slice(0, 80) : "",
          format: format,
          opts: {
            useCollection: useCollection,
            binderId: useCollection && $("[data-ai-binder]").value ? $("[data-ai-binder]").value : null,
            noReuse: useCollection && $("[data-ai-noreuse]").checked,
            casual: $("[data-ai-pool]").value === "casual",
            budget: !useCollection && budget > 0 ? budget : null,
            bracket: isCmd() && $("[data-ai-bracket]").value ? parseInt($("[data-ai-bracket]").value, 10) : null,
            commander: isCmd() && $("[data-ai-commander]").value.trim() ? $("[data-ai-commander]").value.trim() : null,
            exclude: exclude,
            include: list("[data-ai-include]").filter(function (v) { return !ex.has(v.toLowerCase()); })
          }
        };
      }
    };
  };

  // ================================================================ the "new deck" sheet

  KD.create = {
    open: function (o) {
      o = o || {};
      var mode = o.mode || "choose";
      var s = KD.sheet({ title: "New deck", body: "", foot: "", size: "lg" });
      var body = s.body;
      var foot = document.createElement("div");
      foot.className = "sheet__foot";
      s.el.appendChild(foot);

      function setTitle(t, sub) {
        KD.$(".sheet__head h3", s.el).textContent = t;
        var p = KD.$(".sheet__head p", s.el);
        if (sub) { if (!p) { p = document.createElement("p"); KD.$(".sheet__head h3", s.el).after(p); } p.textContent = sub; } else if (p) p.remove();
      }

      function choose() {
        setTitle("New deck", "How do you want to start?");
        body.innerHTML = '<div class="ways">' +
          '<button type="button" class="is-primary" data-way="ai"><span class="ico">' + KD.icon("sparkle") + "</span><span><b>Describe it</b><small>The Kraken reads the live meta and builds the whole list.</small></span></button>" +
          '<button type="button" data-way="empty"><span class="ico">' + KD.icon("layers") + "</span><span><b>Start empty</b><small>Search and add cards yourself.</small></span></button>" +
          '<button type="button" data-way="import"><span class="ico">' + KD.icon("download") + "</span><span><b>Import a list</b><small>Paste from Moxfield, Archidekt, Arena or anywhere.</small></span></button>" +
          "</div>";
        foot.hidden = true;
        KD.$$("[data-way]", body).forEach(function (b) { b.addEventListener("click", function () { go(b.dataset.way); }); });
      }

      function aiMode() {
        setTitle("Describe your deck", o.fromLanding ? "Picked up from the homepage. Check the details, then build." : "The Kraken builds the whole list, then checks every card.");
        body.innerHTML = '<div data-form></div><p class="gensline mt-16" data-gensline></p><div data-nudge></div>';
        var form = KD.aiForm(KD.$("[data-form]", body), { showFormat: true, showName: true, format: o.format || "commander", prompt: o.prompt || "", useCollection: !!o.useCollection });
        KD.paintGensLine(KD.$("[data-gensline]", body));
        foot.hidden = false;
        foot.innerHTML = (mode === "choose" ? '<button class="btn btn--ghost" type="button" data-back>Back</button>' : "") +
          '<button class="btn btn--lure" type="button" data-go-ai>' + KD.icon("sparkle") + "<span>Build my deck</span></button>";
        var back = KD.$("[data-back]", foot); if (back) back.addEventListener("click", choose);
        KD.$("[data-go-ai]", foot).addEventListener("click", function () {
          var r = form.read();
          if (!r.prompt) { form.focus(); KD.toast("Describe the deck you want first.", "info"); return; }
          if (D.reviewIntent(r.prompt) && !o._nudged) {
            o._nudged = true;
            KD.$("[data-nudge]", body).innerHTML = '<div class="nudge mt-16">' + KD.icon("info") + " Sounds like you want to improve a deck you already have. Import your list and the Kraken suggests swaps you can pick from, keeping your deck." +
              '<div class="nudge__actions"><button class="btn btn--lure btn--sm" type="button" data-nudge-import>' + KD.icon("download") + "Import my list</button>" +
              '<button class="btn btn--ghost btn--sm" type="button" data-nudge-skip>No, build me a new deck</button></div></div>';
            KD.$("[data-nudge-import]", body).addEventListener("click", function () { importMode(); });
            KD.$("[data-nudge-skip]", body).addEventListener("click", function () { s.close(); KD.create.start(r); });
            return;
          }
          s.close();
          KD.create.start(r);
        });
        setTimeout(function () { form.focus(); if (o.fromLanding) { var g = KD.$("[data-go-ai]", foot); if (g) g.focus({ preventScroll: true }); } }, 80);
      }

      function emptyMode() {
        setTitle("Start an empty deck");
        body.innerHTML = '<label class="field"><span class="label">Deck name</span><input class="input" data-name maxlength="80" placeholder="My next brew" autofocus></label>' +
          '<div class="field"><span class="label">Format</span><div class="chips" data-fmts>' +
          D.FORMATS.map(function (f, i) { return '<button class="chip' + (i === 0 ? " is-on" : "") + '" type="button" data-fmt="' + f[0] + '">' + f[1] + "</button>"; }).join("") + "</div></div>";
        var fmt = "commander";
        KD.$$("[data-fmt]", body).forEach(function (b) { b.addEventListener("click", function () { fmt = b.dataset.fmt; KD.$$("[data-fmt]", body).forEach(function (x) { x.classList.toggle("is-on", x === b); }); }); });
        foot.hidden = false;
        foot.innerHTML = (mode === "choose" ? '<button class="btn btn--ghost" type="button" data-back>Back</button>' : "") + '<button class="btn btn--lure" type="button" data-make>Create deck</button>';
        var back = KD.$("[data-back]", foot); if (back) back.addEventListener("click", choose);
        var make = async function () {
          var name = KD.$("[data-name]", body).value.trim();
          if (!name) { KD.$("[data-name]", body).focus(); KD.toast("Give the deck a name.", "info"); return; }
          var btn = KD.$("[data-make]", foot); btn.disabled = true;
          try { var d = await D.createDeck(name, fmt); s.close(); KD.builder.openTool = "search"; KD.go("deck/" + d.id); }
          catch (e) { console.error(e); btn.disabled = false; KD.toast("Couldn't create the deck.", "err"); }
        };
        KD.$("[data-make]", foot).addEventListener("click", make);
        KD.$("[data-name]", body).addEventListener("keydown", function (e) { if (e.key === "Enter") make(); });
        setTimeout(function () { KD.$("[data-name]", body).focus(); }, 80);
      }

      function importMode() {
        if (o.fromDeckView) setTitle("Copy this deck", "It becomes your own deck to edit. Check the name, then import.");
        else setTitle("Import a list", "One card per line, like “4 Lightning Bolt”. CSV exports work too.");
        body.innerHTML = '<div class="aiform__row"><label class="field"><span class="label">Deck name</span><input class="input" data-name maxlength="80" placeholder="Imported deck" value="' + esc(o.name || "") + '"></label>' +
          '<label class="field"><span class="label">Format</span><select class="select" data-fmt-sel>' + D.FORMATS.map(function (f) { return '<option value="' + f[0] + '"' + (o.format === f[0] ? " selected" : "") + ">" + f[1] + "</option>"; }).join("") + "</select></label></div>" +
          '<label class="field mt-16"><span class="label">Decklist</span><textarea class="textarea" data-list style="min-height:200px" placeholder="1 Sol Ring&#10;1 Arcane Signet&#10;4 Llanowar Elves">' + esc(o.list || "") + "</textarea></label>";
        foot.hidden = false;
        foot.innerHTML = (mode === "choose" ? '<button class="btn btn--ghost" type="button" data-back>Back</button>' : "") + '<button class="btn btn--lure" type="button" data-imp>' + KD.icon("download") + "<span>Import</span></button>";
        var back = KD.$("[data-back]", foot); if (back) back.addEventListener("click", choose);
        KD.$("[data-imp]", foot).addEventListener("click", async function () {
          var text = KD.$("[data-list]", body).value;
          var parsed = D.parseListText(text);
          if (!parsed.entries.length) { KD.toast("No cards found in that list.", "info"); return; }
          var name = KD.$("[data-name]", body).value.trim() || "Imported deck";
          var fmt = KD.$("[data-fmt-sel]", body).value;
          s.close();
          var d;
          try { d = await D.createDeck(name, fmt); }
          catch (e) { KD.toast("Couldn't create the deck.", "err"); return; }
          KD.builder.pendingImport = parsed;
          KD.go("deck/" + d.id);
        });
      }

      function go(m) {
        if (m === "ai") aiMode(); else if (m === "empty") emptyMode(); else if (m === "import") importMode(); else choose();
      }
      go(mode);
      return s;
    },

    // Run a generation: create the deck if needed, show the dive, write the cards, open the builder.
    start: async function (r, deck) {
      var g = D.gens();
      if (!g.unlimited && g.left <= 0) { KD.upsell(); return; }
      var o = r.opts || {};
      KD.ga("generate_start", { format: r.format, collection: !!o.useCollection });
      try {
        if (!deck) {
          KD.busy("Creating your deck…");
          // no name given: a placeholder until the build is done, then the Kraken names it
          try { deck = r.name ? await D.createDeck(r.name, r.format) : await D.createDeck("New deck", r.format, true); } finally { KD.idle(); }
        }
        if (o.useCollection && o.noReuse) {
          try { var res = await D.computeReserved(deck.id); if (Object.keys(res.map).length) o.reserved = res.map; }
          catch (e) { KD.toast("Couldn't check your other decks, so this build may reuse their cards.", "info"); }
        }
        if (o.binderId) {
          var pool = (S.collection || []).filter(function (c) { return (c.binderIds || []).indexOf(o.binderId) !== -1; }).length;
          if (!pool) { KD.toast("That binder has no cards yet. Add some or pick another.", "err"); KD.go("deck/" + deck.id); return; }
        }
      } catch (e) { console.error(e); KD.toast("Couldn't start the build. Try again.", "err"); return; }

      KD.brew.start({ prompt: r.prompt, format: D.formatLabel(deck.format), size: D.targetSize(deck.format), promo: !S.isPremium });
      try {
        var data = await D.generate(deck, r.prompt, o);
        if (data.error || !data.deckSuggestion) {
          KD.brew.stop();
          KD.toast(data.deckSuggestion && data.error ? data.deckSuggestion : "The deck couldn't be built. Try rephrasing.", "err");
          KD.builder.retry = { prompt: r.prompt };
          KD.go("deck/" + deck.id);
          return;
        }
        // 2026-10-03: a "brawl deck" typed into a Commander request is built as Brawl; keep the deck's
        // format in step so its size, commander rules and card search match what was built
        if (data.format && D.isBrawlFormat(data.format) && data.format !== deck.format) {
          try {
            await D.deckRef(deck.id).update({ format: data.format });
            deck.format = data.format;
            var cachedFmt = (S.decks || []).find(function (x) { return x.id === deck.id; });
            if (cachedFmt) cachedFmt.format = data.format;
          } catch (e) { console.warn("format switch", e); }
        }
        await D.processGeneratedDeck(deck, data.deckSuggestion, data.commander, "replace", data.partner, data.cardData);
        // named before anything publishes it, so the gallery never shows a placeholder (or the prompt)
        if (deck.nameAuto) {
          try { await D.nameNewDeck(deck, { prompt: r.prompt, suggestion: data.deckSuggestion, commander: data.commander, partner: data.partner }); }
          catch (e) { console.error("deck name", e); }
        }
        // free accounts: AI decks are published to the gallery — unless a small binder pool padded
        // the list out with basics, in which case it stays a draft
        var floodHeld = false, published = false;
        if (!S.isPremium) {
          if (o.binderId && D.basicLandFraction(data.deckSuggestion) > 0.45) floodHeld = true;
          else { try { await D.publishDeck(deck.id); published = true; } catch (e) { console.error("auto-publish", e); } }
        }
        try { await D.loadProfile(); } catch (e) { /* the count refreshes next load */ }
        KD.paintGens();
        KD.brew.stop();
        KD.ga("generate_done", { format: deck.format });
        KD.builder.pendingResult = { data: data, floodHeld: floodHeld, published: published };
        var h = "#/deck/" + encodeURIComponent(deck.id);
        if (location.hash === h) KD.router(); else location.hash = h;
      } catch (e) {
        console.error("generate", e);
        KD.brew.stop();
        if (e.code === "functions/resource-exhausted") KD.upsell(e.message);
        else if (e.code === "functions/failed-precondition" && e.message) KD.toast(e.message, "err");
        else KD.toast("The build failed. Please try again.", "err");
        try { await D.loadProfile(); KD.paintGens(); } catch (err) { /* ignore */ }
        KD.builder.retry = { prompt: r.prompt };
        KD.go("deck/" + deck.id);
      }
    }
  };
})();
